const currentDate = new Date();
function setWithExpiry(key, value) {
  const timeoutDate = new Date().setDate(currentDate.getDate() + 7);
  const item = {
    value: value,
    expiry: timeoutDate,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const expiry = new Date(item.expiry).getTime();

  if (currentDate.getTime() > expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

$(function () {
  const hasDate = getWithExpiry("newsletterPopupClosed");

  // Instagram's in-app browser causes sporadic unusability due to hidden content
  // this check will not show the pop up if the user has come from Instagram.
  const { userAgent } = navigator;
  const isInstagramAgent = userAgent.indexOf("Instagram") != -1;

  if (hasDate || isInstagramAgent) return;
  if (!window.location.pathname.includes("account/activate")) {
    setTimeout(() => {
      $(".js-newsletter-popup").removeClass("hidden");
      $(".js-newsletter-popup").css("display", "block");
      $("body").toggleClass("no-scroll");
    }, 60000);
  }
});

if ($(".js-newsletter-popup-close")) {
  $(".js-newsletter-popup-close").on("click", function () {
    $(".js-newsletter-popup").addClass("hidden");
    $("body").toggleClass("no-scroll");
    setWithExpiry("newsletterPopupClosed", currentDate);
  });
}

$(function () {
  if ($("#newsletter-popup-subscribe")) {
    $("#newsletter-popup-subscribe").on("click", function () {
      $(".newsletter-popup-first").addClass("hidden");
      $(".newsletter-popup-second").removeClass("hidden");
      setWithExpiry("newsletterPopupClosed", currentDate);
    });
  }
});
